export default [    //通知提醒
  {
    path: "/notice",
    name: 'notice',
    component: () => import("@/views/notice/notice.vue")
  },
  {
    path: "/system_notice",
    name: 'systemNotice',
    component: () => import("@/views/notice/system_notice.vue")
  }
]
